import Joi from "joi";
import { maxLength } from "../../helpers/data-constants";
import errorsResolver from "../schemeUtils";

 export const clientDecisionMakersInfoScheme = Joi.object({
  decisionMakersInfo: Joi.string()
    .allow("")
    .max(maxLength.SERVICE_INFORMATION_RISK)
    .pattern(
      new RegExp(
        `^[a-zA-Zа-яА-ЯёЁ0-9() *\\/?!%{}[\\]^<>,-.|№"_=&$#~@+\'\\\\ \n\r:;«»\`]{1,${maxLength.SERVICE_INFORMATION_RISK}}$`
      )
    )
    .error(
      errorsResolver({
        max: `Поле должно быть до ${maxLength.SERVICE_INFORMATION_RISK} символов`,
        pattern: `Поле содержит некорректные символы`,
      })
    ),
});
